import React from 'react';
import { motion } from 'framer-motion';
export function Slide5Menu() {
  const menuItems = [{
    stage: 'Pre-Congress',
    name: 'Insight Snak',
    channels: 'Email, WhatsApp, banners, portals, rep links',
    format: 'Hook GIF + short Teaser Snak',
    output: 'Knowledge gaps, topic interest, early segmentation',
    price: '€4,000–€6,000'
  }, {
    stage: 'Vicinity',
    name: 'Attention Snak',
    channels: 'Airport, station, hotel, outdoor, Uber, QR',
    format: 'Hook GIF + short Teaser Snak',
    output: 'First engagement, scan source, booth intent',
    price: '€4,000–€6,000'
  }, {
    stage: 'Venue',
    name: 'Reminder Snak',
    channels: 'Screens, banners, posters, digital signage, QR',
    format: 'Hook GIF + short Teaser Snak',
    output: 'Message resonance and channel performance',
    price: '€4,000–€6,000'
  }, {
    stage: 'Aisle',
    name: 'Ice-Breaker Snak',
    channels: 'Rep iPad, booth screen, QR, touchscreen',
    format: 'Teaser Snak or short Trailer Snak',
    output: 'Specialty, interest area, conversation starter',
    price: '€6,000–€9,000'
  }, {
    stage: 'Booth',
    name: 'Conversation Snak',
    channels: 'iPad, touchscreen, rep-led discussion',
    format: 'Talk Snak with input and feedback cues',
    output: 'Preferences, objections, consent, next action',
    price: '€6,000–€10,000'
  }, {
    stage: 'Post-Congress',
    name: 'Follow-Up Snak',
    channels: 'Email, rep follow-up, CRM-triggered link, WhatsApp',
    format: 'Follow-up Snak or short Trailer Snak',
    output: 'Segmented follow-up and campaign learning',
    price: '€2,500–€4,000'
  }];
  return <div className="h-full w-full bg-[#F8F9FA] text-[#2D3748] flex flex-col p-12 md:px-24 md:pt-16 md:pb-24 relative overflow-hidden" data-id="element-168">
      <header className="mb-8" data-id="element-169">
        <motion.h2 className="text-4xl md:text-5xl font-bold text-[#1A202C] mb-4" initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-170">
          Choose the use case that solves the current challenge.
        </motion.h2>
        <motion.p className="text-xl text-[#4A5568] font-light" initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} data-id="element-171">
          Each menu item can stand alone as a focused pilot.
        </motion.p>
      </header>

      <main className="flex-1 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-172">
        {menuItems.map((item, index) => <motion.div key={item.stage} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden flex flex-col" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2 + index * 0.1
      }} data-id="element-173">
            <div className="bg-[#1A202C] text-white px-6 py-4 border-b-4 border-[#E60012]" data-id="element-174">
              <div className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-1" data-id="element-175">
                {item.stage}
              </div>
              <h3 className="text-xl font-semibold" data-id="element-176">{item.name}</h3>
            </div>

            <div className="p-6 flex-1 flex flex-col gap-4 text-sm" data-id="element-177">
              <div data-id="element-178">
                <span className="text-gray-400 uppercase text-[10px] font-bold tracking-wider block mb-1" data-id="element-179">
                  Channels
                </span>
                <p className="text-[#2D3748]" data-id="element-180">{item.channels}</p>
              </div>
              <div data-id="element-181">
                <span className="text-gray-400 uppercase text-[10px] font-bold tracking-wider block mb-1" data-id="element-182">
                  Format
                </span>
                <p className="text-[#2D3748]" data-id="element-183">{item.format}</p>
              </div>
              <div data-id="element-184">
                <span className="text-gray-400 uppercase text-[10px] font-bold tracking-wider block mb-1" data-id="element-185">
                  Output
                </span>
                <p className="text-[#6B46C1] font-medium" data-id="element-186">{item.output}</p>
              </div>
              <div className="mt-auto pt-4 border-t border-gray-100" data-id="element-187">
                <span className="text-gray-400 uppercase text-[10px] font-bold tracking-wider block mb-1" data-id="element-188">
                  Indicative Price
                </span>
                <p className="text-[#E60012] font-bold" data-id="element-189">{item.price}</p>
              </div>
            </div>
          </motion.div>)}
      </main>

      <motion.footer className="mt-10 mb-4 text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.6,
      delay: 1
    }} data-id="element-190">
        <p className="text-[#4A5568] font-medium bg-white inline-block px-6 py-2 rounded-full shadow-sm border border-gray-100" data-id="element-191">
          Start with one use case. Expand only if the data supports it.
        </p>
      </motion.footer>
    </div>;
}